import React, { useState, useRef, useEffect } from "react";
import style from "./variantCardHint.module.scss"


const VariantCardHint = (props) => {

    const [paragraphNumber, setParagraphNumber] = useState('')

    const handleParagraphs = number => {
        if (paragraphNumber == number) {
            setParagraphNumber('')
        } else {
            setParagraphNumber(number)
        }
    }

    return (
        <div className={style.wrapper}>
            <p className={style.mainTitle}>قیمت خرید</p>
            <p className={style.mainDesc}>قیمت خرید محصول خود را وارد کنید
                این قیمت مبنای محاسبه‌ی حداقل و حداکثر قیمت تنوع خواهد بود
            </p>
            <p className={style.mainTitle}>حداقل حاشیه سود</p>
            <p className={style.mainDesc}>حداقل حاشیه سود برای این کالا را وارد کنید</p>

            <ul>
                <li
                    className={style.listStyle}
                    onClick={() => handleParagraphs('0')}
                >
                    <p>درصد
                        <span className={paragraphNumber == '0' ? style.openArrow : style.arrow}>c</span>
                    </p>
                    {paragraphNumber == '0' && <div className={style.subDesc}>
                        کمترین میزان سود شما، براساس درصد وارد شده نسبت به قیمت خرید خواهد بود
                    </div>}
                </li>
                <li
                    className={style.listStyle}
                    onClick={() => handleParagraphs('1')}
                >
                    <p>مبلغ
                        <span className={paragraphNumber == '1' ? style.openArrow : style.arrow}>c</span>
                    </p>
                    {paragraphNumber == '1' && <div className={style.subDesc}>
                        کمترین میزان سود شما، مبلغ وارد شده خواهد بود
                    </div>}
                </li>
                <li
                    className={style.listStyle}
                    onClick={() => handleParagraphs('2')}
                >
                    <p>قیمت نهایی 
                        <span className={paragraphNumber == '2' ? style.openArrow : style.arrow}>c</span>
                    </p>
                    {paragraphNumber == '2' && <div className={style.subDesc}>
                        حداقل قیمت فروش، قیمت وارد شده خواهد بود
                    </div>}
                </li>
            </ul>

        </div >
    );
}

export default VariantCardHint;
